import React from 'react';

const SimRadioButton = ({ label, name = "customRadio", id = "customRadio", onChange, checked }) => {
    return (
        <div className="custom-radio-container">
            <label htmlFor={id} className="custom-radio-label">
                <input type="radio" id={id} name={name} className="custom-radio-input" onChange={onChange} checked={checked} />
                {label}
            </label>
        </div>
    );
};

export default SimRadioButton;
